import styled from 'styled-components';

import { titles } from '@proprioo/salatim';

export const Title = styled.h6`
  ${titles.h6};
  margin: 0;
`;
